import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const [authTimeout, setAuthTimeout] = useState(false);

  // Set a timeout for auth loading to prevent infinite loading - increased for Safari
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loading) {
        console.warn('Auth loading timeout reached, redirecting to auth page');
        setAuthTimeout(true);
      }
    }, 30000); // 30 second timeout for Safari compatibility

    return () => clearTimeout(timeout);
  }, [loading]);

  // If timeout reached or not loading and no user, redirect to auth
  if (authTimeout || (!loading && !user)) {
    return <Navigate to="/auth" replace />;
  }

  if (loading && !authTimeout) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-400 to-purple-600">
        <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <h2 className="text-xl font-semibold text-gray-800">Loading...</h2>
          <p className="text-sm text-gray-600">Checking authentication</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

